import * as React from 'react';
import HeaderBodyContainer from 'nomst/Components/SharedJobCollab/headerBodyContainer';
import './detailsSection.scss';

interface DetailsSectionProps {
    children?: React.ReactNode;
    title?: Nullable<string>;
    className?: string;
}

const DetailsSection = (props: DetailsSectionProps): JSX.Element => {
    const { title } = props;
    return <HeaderBodyContainer
        header={title ? <div className="details-section-header">{title}</div> : null}
        containerClassName={`details-section ${props.className || ''}`}
        bodyClassName="details-section-body"
    >
        {props.children}
    </HeaderBodyContainer>;
};

export { DetailsSection };
export default DetailsSection;